import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
  return (
    <motion.div 
      className="flex items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="relative mr-2">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Genie Lamp Base */}
          <path 
            d="M8 28C8 28 12 26 20 26C28 26 32 28 32 28V30C32 30 28 28 20 28C12 28 8 30 8 30V28Z" 
            fill="#D4AF37" 
            className="text-pale-gold"
          />
          
          {/* Lamp Body */}
          <path 
            d="M10 28C10 28 10 22 14 18C18 14 22 14 26 18C30 22 30 28 30 28" 
            stroke="#D4AF37" 
            strokeWidth="2.5" 
            strokeLinecap="round"
            className="text-pale-gold"
          />
          
          {/* Lamp Handle */}
          <path 
            d="M30 28C30 28 32 25 32 24C32 22.5 31 21 29 21" 
            stroke="#D4AF37" 
            strokeWidth="2.5" 
            strokeLinecap="round"
            className="text-pale-gold"
          />
          
          {/* Data Trail / Magic Smoke */}
          <motion.path
            d="M20 18C20 18 19 14 20 10C21 6 24 4 24 4"
            stroke="#4285F4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="44"
            strokeDashoffset="44"
            animate={{ strokeDashoffset: 0 }}
            transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
            className="text-electric-blue"
          />
          
          <motion.path
            d="M20 18C20 18 21 12 18 8"
            stroke="#4285F4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="44"
            strokeDashoffset="44"
            animate={{ strokeDashoffset: 0 }}
            transition={{ duration: 1.5, delay: 0.3, repeat: Infinity, repeatType: "reverse" }}
            className="text-electric-blue"
          />
          
          <motion.path
            d="M20 18C20 18 16 14 16 10"
            stroke="#4285F4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="44"
            strokeDashoffset="44"
            animate={{ strokeDashoffset: 0 }}
            transition={{ duration: 1.5, delay: 0.6, repeat: Infinity, repeatType: "reverse" }}
            className="text-electric-blue"
          />
          
          {/* Sparkles */}
          <motion.circle 
            cx="16" 
            cy="8" 
            r="1" 
            fill="#D4AF37"
            animate={{ 
              opacity: [0, 1, 0],
              scale: [0.8, 1.2, 0.8]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            className="text-pale-gold"
          />
          
          <motion.circle 
            cx="24" 
            cy="6" 
            r="1" 
            fill="#D4AF37"
            animate={{ 
              opacity: [0, 1, 0],
              scale: [0.8, 1.2, 0.8]
            }}
            transition={{ 
              duration: 2,
              delay: 0.7,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            className="text-pale-gold"
          />
          
          <motion.circle 
            cx="20" 
            cy="4" 
            r="1" 
            fill="#D4AF37"
            animate={{ 
              opacity: [0, 1, 0],
              scale: [0.8, 1.2, 0.8]
            }}
            transition={{ 
              duration: 2,
              delay: 1.4,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            className="text-pale-gold"
          />
        </svg>
      </div>
      <div>
        <h1 className="text-xl font-bold text-midnight-navy">
          Research<span className="text-pale-gold">Genie</span>
        </h1>
      </div>
    </motion.div>
  );
};

export default Logo;
